import { ActionBase } from '../actions/action-base';
//
// Library
//
import * as Library from '../../../lib/core/library/index';
import { FeatureConfig } from '../../../lib/angular/model/dealer/feature-config';
//
// Actions
//
import {
  FEATURE_CONFIG_ACTION,
  FeatureConfigActionLoad,
  FeatureConfigActionSet,
  FeatureConfigActionClear
} from '../actions/feature-config.action';
//
// Reducer Interface
//
export interface IFeatureConfig {
  hasItems: boolean;
  items: FeatureConfig[];
}
//
// Initial State
//
export const FEATURE_CONFIG_INITIAL_STATE: IFeatureConfig = {
  hasItems: false,
  items: []
};

/* tslint:disable:no-switch-case-fall-through */
export function FeatureConfigReducer(
  state = FEATURE_CONFIG_INITIAL_STATE,
  action: ActionBase
): IFeatureConfig {
  //
  // Switch on Action Type
  //
  switch (action.type) {
    case FEATURE_CONFIG_ACTION.LOAD:
      return _onLoad(state, action as FeatureConfigActionLoad);
      case FEATURE_CONFIG_ACTION.SET:
      return _onSet(state, action as FeatureConfigActionSet);
    default: {
      return state;
    }
  }
}
//
// General Functions
//
export function LoadFeatureConfig(state: IFeatureConfig) {
  return state;
}

//
// _onLoad()
//
function _onLoad(state: IFeatureConfig, action: FeatureConfigActionLoad): IFeatureConfig {

  return Object.assign({}, state);
}

//
// _onSet()
//
function _onSet(state: IFeatureConfig, action: FeatureConfigActionSet): IFeatureConfig {
  const _state = Object.assign({}, state, {
    items: action.payload,
    hasItems: Library.isArrayWithLength(action.payload)
  });
  //
  // Do Work...
  //
  return _state;
}

//
// _onClear()
//
function _onClear(state: IFeatureConfig, action: FeatureConfigActionClear): IFeatureConfig {
  //
  // Do Work...
  //
  return Object.assign({}, state, { items: [] });
}

